module.exports = __webpack_public_path__ + "static/media/arvikavapen.10e59103.png";